'use client'
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu"
import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import { HeaderNavbarFetchedData } from "@/Types/FetchedDataTypes";
import baseApi from "@/utils/baseApiUrl";

interface ComponentProps {
  navMenu: HeaderNavbarFetchedData[],
  logo: {
    companyLogo: {
      id: string,
      filename_disk: string,
      title: string,
      description: null | string,
      width: number,
      height: number
    }
  }
}

export default function LogoWithNavHeader({ navMenu, logo }: ComponentProps) {
  const { scrollY } = useScroll();
  const [isFixed, setIsFixed] = useState<boolean>(false)
  const [headerMenu, setHeaderMenu] = useState<[] | HeaderNavbarFetchedData[]>(navMenu ? navMenu : [])
  useMotionValueEvent(scrollY, "change", (scrollValue) => { // Tracks and checks the scroll value if its greater than 300 or not.
    if (scrollValue > 200) setIsFixed(true)
    if (scrollValue < 200) setIsFixed(false)
  })
  const API = baseApi()

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 2 } }}
        className="flex justify-between items-center p-[30px] text-gray-text px-16 font-rubik bg-white z-50 w-full max-[1100px]:flex-col max-[1100px]:items-center max-[1100px]:gap-5 max-[800px]:hidden"
      >
        <div>
          <Link href={'/'}>
            <Image src={`${API}/assets/${logo.companyLogo.filename_disk}`} alt="CaressFlowLogo" width={logo.companyLogo.width} height={logo.companyLogo.height} />
          </Link>
        </div>

        <div className="flex justify-center items-center space-x-5 font-heebo text-base">

          {headerMenu.map((menuItem: HeaderNavbarFetchedData) => {
            if (menuItem.dropdownButtons) {
              return (
                <NavigationMenu key={menuItem.id}>
                  <NavigationMenuList>
                    <NavigationMenuItem>
                      <NavigationMenuTrigger className="text-gray-text hover:text-pink-bg duration-150 ease-in-out text-base">
                        {menuItem.slug ? <Link className="hover:text-pink-bg duration-150 ease-in-out " href={`/${menuItem.slug}`}>{menuItem.buttonTitle}</Link> : `${menuItem.buttonTitle}`}
                      </NavigationMenuTrigger>
                      <NavigationMenuContent>
                        <ul className="grid w-[200px] gap-4">
                          {menuItem.dropdownButtons.map((drop) =>
                            <li key={drop.buttonTitle}>
                              <NavigationMenuLink href={`/${drop.slug}`} className="text-gray-text hover:text-pink-bg">{drop.buttonTitle}</NavigationMenuLink>
                            </li>
                          )}
                        </ul>
                      </NavigationMenuContent>
                    </NavigationMenuItem>
                  </NavigationMenuList>
                </NavigationMenu>
              )
            } else {
              return (
                <Link className="hover:text-pink-bg duration-150 ease-in-out" key={menuItem.id} href={`/${menuItem.slug}`}>{menuItem.buttonTitle}</Link>
              )
            }
          })}

        </div>

        <div className="pl-[300px]">
        </div>

      </motion.div>

      {/* FIXED HEADER COMES IN AFTER SCROLL RATE IS GREATER THAN 300 */}

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 2 } }}
        style={{
          y: isFixed ? '0%' : '-300%',
        }}
        className="flex justify-between items-center p-[30px] text-gray-text px-16 font-rubik bg-white z-50 w-full fixed duration-500
        max-[1100px]:flex-col max-[1100px]:items-center max-[1100px]:gap-5 max-[800px]:hidden"
      >
        <div>
          <Link href={'/'}>
            <Image src={`${API}/assets/${logo.companyLogo.filename_disk}`} alt="CaressFlowLogo" width={logo.companyLogo.width} height={logo.companyLogo.height} />
          </Link>
        </div>

        <div className="flex justify-center items-center space-x-5 font-heebo text-base"></div>

        <div className="flex justify-center items-center space-x-5 font-heebo text-base">
          {headerMenu.map((menuItem) => {
            if (menuItem.dropdownButtons) {
              return (
                <NavigationMenu key={menuItem.id}>
                  <NavigationMenuList>
                    <NavigationMenuItem>
                      <NavigationMenuTrigger className="text-gray-text hover:text-pink-bg duration-150 ease-in-out text-base">
                        {menuItem.slug ? <Link className="hover:text-pink-bg duration-150 ease-in-out " href={`/${menuItem.slug}`}>{menuItem.buttonTitle}</Link> : `${menuItem.buttonTitle}`}
                      </NavigationMenuTrigger>
                      <NavigationMenuContent>
                        <ul className="grid w-[200px] gap-4">
                          {menuItem.dropdownButtons.map((drop) =>
                            <li key={drop.buttonTitle}>
                              <NavigationMenuLink href={`/${drop.slug}`} className="text-gray-text hover:text-pink-bg">{drop.buttonTitle}</NavigationMenuLink>
                            </li>
                          )}
                        </ul>
                      </NavigationMenuContent>
                    </NavigationMenuItem>
                  </NavigationMenuList>
                </NavigationMenu>
              )
            } else {
              return (
                <Link className="hover:text-pink-bg duration-150 ease-in-out" key={menuItem.id} href={`/${menuItem.slug}`}>{menuItem.buttonTitle}</Link>
              )
            }
          })}
        </div>

        <div className="pl-[300px]">
        </div>
      </motion.div>
    </>
  );
}
